export enum TYPE_OF_PAYMENT_METHOD {
  credit_card = "credit_card",
  check = "check",
  bank_transfer = "bank_transfer",
  cash = "cash",
}
